// extracted by mini-css-extract-plugin
module.exports = {"headerContent":"designers-header_headerContent__nMDe7","title":"designers-header_title__m87kf"};